document.addEventListener('DOMContentLoaded', function () {
  // Debounce function for better performance
  const debounce = (func, delay) => {
    let timeout;
    return function (...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), delay);
    };
  };

  // Elements
  const mainMediaContainer = document.querySelector('.product__media-wrapper');
  const carousel = document.querySelector('.horizontal-slider');
  const nextButton = document.querySelector('.slider-button--next');
  const prevButton = document.querySelector('.slider-button--prev');
  const indicatorsContainer = document.querySelector('.slider-indicators');
  const thumbnailsContainer = document.querySelector('.carousel-thumbnails');
  const zoomOpenerBtn = document.querySelector(
    '.slider--horizontal .media-img-zoom'
  );
  const originalSlides = Array.from(
    mainMediaContainer.querySelectorAll('.slider__slide')
  );

  // Dimensions & counters
  let slideWidth = originalSlides[0].offsetWidth;
  const totalOriginalSlides = originalSlides.length;
  let currentIndex = totalOriginalSlides; // Start at the "center" (after prepended clones)
  let isTransitioning = false;
  let isUserScrolling = true; // Initialize this variable
  let isClicked = false; // Initialize this variable

  // For initial load, disable smooth scroll so the user doesn't see a jump.
  carousel.style.scrollBehavior = 'auto';

  // Circular linked list logic for appending slides
  const appendSlides = () => {
    const batch = originalSlides.map((slide) => slide.cloneNode(true));
    batch.forEach((clone) => carousel.appendChild(clone)); // Append the batch to the end
  };

  // Circular linked list logic for prepending slides
  const prependSlides = () => {
    const batch = originalSlides
      .slice()
      .reverse()
      .map((slide) => slide.cloneNode(true));
    batch.forEach((clone) => carousel.prepend(clone)); // Prepend the batch to the beginning
    currentIndex += totalOriginalSlides; // Adjust the current index
  };

  // Initial clone setup
  appendSlides();
  prependSlides();

  setTimeout(() => {
    carousel.style.scrollBehavior = 'smooth';
  }, 500);

  if (prevButton) {
    prevButton.setAttribute('disabled', 'true');
  }

  // Create indicators for original slides
  if (indicatorsContainer) {
    for (let i = 0; i < totalOriginalSlides; i++) {
      const indicator = document.createElement('span');
      indicator.classList.add('indicator');
      if (i === 0) indicator.classList.add('active');
      indicatorsContainer.appendChild(indicator);
    }
  }
  const indicators = document.querySelectorAll('.indicator');

  const updateIndicators = () => {
    // Calculate the visible slide index in the original set
    const actualIndex =
      (((currentIndex - totalOriginalSlides) % totalOriginalSlides) +
        totalOriginalSlides) %
      totalOriginalSlides;
    indicators.forEach((ind, idx) => {
      ind.classList.toggle('active', idx === actualIndex);
    });
  };

  // Highlight the active thumbnail
  const updateActiveThumbnail = (activeIndex) => {
    if (!thumbnailsContainer) return;

    const thumbnails = document.querySelectorAll('.thumbnail-item');
    thumbnails.forEach((thumb, idx) => {
      if (idx === activeIndex) {
        thumb.classList.add('is-active');
        thumb.style.opacity = '1'; // Fully visible for the active thumbnail
      } else {
        thumb.classList.remove('is-active');
        thumb.style.opacity = '0.5'; // Blurry effect for non-active thumbnails
      }
    });
  };

  // Get the currently visible slide
  const getCurrentSlide = () => {
    // Calculate the visible slide index in the original set
    const actualIndex =
      (((currentIndex - totalOriginalSlides) % totalOriginalSlides) +
        totalOriginalSlides) %
      totalOriginalSlides;

    // Return the original slide based on the calculated index
    return originalSlides[actualIndex];
  };

  // Moves to the current slide (by scrollLeft) with locking to prevent rapid triggering
  const scrollToCurrentSlide = () => {
    if (isTransitioning) return; // Prevent multiple triggers
    isTransitioning = true;

    // Scroll to the calculated position based on the current index
    carousel.scrollTo({
      left: slideWidth * (currentIndex % totalOriginalSlides),
      behavior: 'smooth', // Smooth scrolling
    });

    // Allow a little extra time than the transition to reset the flag
    setTimeout(() => {
      isTransitioning = false;
      isUserScrolling = true; // Re-enable user scrolling flag
    }, 350);

    // Update indicators and active thumbnail
    updateIndicators();
    const visibleIndex =
      (((currentIndex - totalOriginalSlides) % totalOriginalSlides) +
        totalOriginalSlides) %
      totalOriginalSlides;
    updateActiveThumbnail(visibleIndex);
  };

  // Previous button event
  if (prevButton) {
    prevButton.addEventListener(
      'click',
      debounce(() => {
        const totalSlides = carousel.querySelectorAll('.slider__slide').length;

        if (currentIndex === 0) {
          currentIndex = totalSlides - 1; // Wrap around to the last slide
          scrollToCurrentSlide();
        }
        if (currentIndex > 0) {
          currentIndex--; // Move to the previous slide
          scrollToCurrentSlide();
        }
      }, 200)
    );
  }

  // Next button event
  if (nextButton) {
    nextButton.addEventListener(
      'click',
      debounce(() => {
        const totalSlides = carousel.querySelectorAll('.slider__slide').length;

        if (currentIndex < totalSlides - 1) {
          currentIndex++; // Move to the next slide
          scrollToCurrentSlide();
        }
      }, 200)
    );
  }

  // Listen to scroll events to update indicators and thumbnails dynamically
  carousel.addEventListener(
    'scroll',
    debounce(() => {
      isUserScrolling = true; // Enable user scrolling flag
      isClicked = false; // Reset clicked state
      // Estimate the current index based on scrollLeft
      let indexEstimate = Math.round(carousel.scrollLeft / slideWidth);

      if (indexEstimate !== currentIndex) {
        currentIndex = indexEstimate;
        updateIndicators();

        const visibleIndex =
          (((currentIndex - totalOriginalSlides) % totalOriginalSlides) +
            totalOriginalSlides) %
          totalOriginalSlides;
        updateActiveThumbnail(visibleIndex);
      }

      // When the scroll position nears either boundary, add clones in batches
    }, 100)
  );

  // Create thumbnails for mobile view
  const createThumbnails = () => {
    if (!thumbnailsContainer) return;

    thumbnailsContainer.innerHTML = ''; // Clear existing thumbnails
    originalSlides.forEach((slide, index) => {
      const imgElement = slide.querySelector('img');
      if (!imgElement) return;

      const thumbnail = document.createElement('div');
      thumbnail.classList.add('thumbnail-item');
      thumbnail.dataset.index = index;
      thumbnail.innerHTML = `<img src="${imgElement.src}" alt="Thumbnail ${
        index + 1
      }" />`;
      thumbnailsContainer.appendChild(thumbnail);

      // Add click event to navigate to the corresponding slide
      thumbnail.addEventListener(
        'click',
        debounce(() => {
          currentIndex = index + totalOriginalSlides; // Adjust for clones
          scrollToCurrentSlide();
        }, 200)
      );
    });
  };

  // Initialize thumbnails
  createThumbnails();
  updateActiveThumbnail(0);

  // Initialize the flag for user scrolling
  isUserScrolling = true;

  // Adjust dimensions on window resize
  window.addEventListener(
    'resize',
    debounce(() => {
      slideWidth = originalSlides[0].offsetWidth;
      carousel.scrollLeft = slideWidth * currentIndex;
    }, 200)
  );

  // Enhanced zoom button handler to open modal with current slide
  if (zoomOpenerBtn) {
    zoomOpenerBtn.addEventListener('click', () => {
      const modal = document.querySelector('product-modal');
      if (modal) {
        // Get current slide
        const currentSlide = getCurrentSlide();

        // Find the media element in the slide that has a data-media-id
        const mediaElement = currentSlide.querySelector('[data-media-id]');

        if (mediaElement) {
          // Create a temporary element that mimics what the product-modal expects
          const openerElement = document.createElement('div');
          openerElement.setAttribute(
            'data-media-id',
            mediaElement.getAttribute('data-media-id')
          );

          // Store a reference to this element on the modal
          modal.openedBy = openerElement;

          // Open the modal
          modal.setAttribute('open', '');

          // Ensure the modal shows the correct media
          setTimeout(() => {
            if (typeof modal.showActiveMedia === 'function') {
              modal.showActiveMedia();
            }
          }, 100);
        } else {
          // Fallback if no media ID is found
          modal.setAttribute('open', '');
        }
      }
    });
  }
});
